import lodash from 'lodash';
import React, { Component } from 'react';
import { Tabs } from 'antd';
import { Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import LeadHistory from '../Lead_history/LeadHistory';
import LeadProfilePhotos from '../Lead_profile_photos/Lead_profile_photos';
import BlemishReportResultTab from '../Lead_profile_blemish_report/components/BlemishReportResultTab';
import PaymentApprovalDetails from '../../../LeadPaymentApproval/components/paymentApproval/PaymentApprovalDetails';
import { VIEW_LEAD_PROFILE_URL } from '../../../LeadPaymentApproval/constants';
import LeadConversationTab from '../Lead_conversation_tab/Lead_conversation_tab';
import LeadDispositionTab from '../Lead_disposition_tab/Lead_disposition_tab';


const { TabPane } = Tabs;

class LeadProfileInfo extends Component {
    state = {
        activeTab: '0',
    };

    toggle = (tab) => {
        const { activeTab } = this.state;

        if (activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    };

    render() {
        const { activeTab } = this.state;
        const {
            Leads,
            lead_finance_loading,
            lead_finance,
        } = this.props;

        return Leads
            && (
                <Paper style={{ padding: 24, marginTop: 10 }}>
                    <Tabs defaultActiveKey={activeTab} onChange={this.toggle}>
                        <TabPane tab="Lead Disposition" key="0">
                            <LeadDispositionTab />
                        </TabPane>
                        <TabPane tab="Lead Conversation" key="1">
                            <LeadConversationTab />
                        </TabPane>
                        <TabPane tab="Lead Photos" key="2">
                            <LeadProfilePhotos />
                        </TabPane>
                        <TabPane tab="Blemish Report" key="3">
                            <BlemishReportResultTab
                                hasCompletedBlemish={lodash.get(Leads, 'Lead_profile.Ref_bike_lead.has_completed_blemish')}
                                step={lodash.get(Leads, 'Lead_profile.Ref_bike_lead.completed_blemish_step')}
                            />
                        </TabPane>
                        <TabPane tab="Payment details" key="4">
                            <PaymentApprovalDetails sourceScreen={VIEW_LEAD_PROFILE_URL} />
                        </TabPane>
                        <TabPane tab="Lead History" key="5">
                            <LeadHistory />
                        </TabPane>
                    </Tabs>
                </Paper>
            );
    }
}

const mapStateToProps = (state) => ({
    lead_finance: state.Leads.Lead_profile.Lead_general.lead_finance,
    lead_finance_loading: state.Leads.Lead_profile.Lead_general.lead_finance_loading,
});

export default connect(mapStateToProps)(LeadProfileInfo);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/LeadProfileInfo.js